<template>
  <!-- Content Wrapper-->
  <div class="content-wrapper">
    <!-- Content Header -->
    <div class="content-header">
      <div class="d-flex align-items-center border-bottom">
        <div class="row">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">Main Dashboard</h1>
            <ol class="breadcrumb float-sm-left">
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Home' }"
                >Home</router-link
              >
              <li class="breadcrumb-item active">Tags Manager</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!-- POV tags-manager start -->

    <!-- Tag cart -->
    <div class="tags-manager">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-row class="pb-2">
        <!-- COL-1 -->
        <v-col
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 card-height"
        >
          <v-card>
            <div>
              <v-card-title>GEO Tags</v-card-title>
              <v-divider></v-divider>
            </div>

            <div class="tags-content">
              <div class="tags-list">
                <v-list-item
                  v-for="tag in filteredTags"
                  :key="tag.id"
                  class="d-none mt-2"
                  :class="{ 'd-flex': tag.type === 'geo' }"
                >
                  <v-list-item-title>
                    <v-chip
                      class="font-weight-medium text-sm-body-2"
                      color="red lighten-4"
                      label
                      small
                      @click="search = tag.name"
                      >{{ tag.name }}</v-chip
                    >
                  </v-list-item-title>
                  <v-list-item-icon
                    @click="
                      id = tag.id;
                      name = tag.name;
                      selectedTagType = 'geo';
                      shwEditPopUp = true;
                    "
                  >
                    <v-icon small>mdi-pencil-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-icon
                    @click="
                      id = tag.id;
                      shwTagsQuestion = true;
                    "
                  >
                    <v-icon small>mdi-trash-can-outline</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </div>

              <v-card-actions>
                <v-btn
                  color="grey"
                  block
                  outlined
                  class="btn-add-tag text-capitalize caption font-weight-medium"
                  @click="
                    shwAddPopUp = true;
                    selectedTagType = 'geo';
                  "
                >
                  <v-icon dark class="caption"> mdi-plus </v-icon>
                  Add tag
                </v-btn>
              </v-card-actions>

              <!-- SPINNER -->
              <div
                v-if="!tags.length && loading"
                class="spinner-border text-primary loading-spinner--center"
                role="status"
                style="top: 48% !important; left: 46% !important"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </v-card>
        </v-col>

        <!-- COL-2 -->
        <v-col
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 card-height"
        >
          <v-card>
            <div>
              <v-card-title>Vertical tags</v-card-title>
              <v-divider></v-divider>
            </div>

            <div class="tags-content">
              <div class="tags-list">
                <v-list-item
                  v-for="tag in filteredTags"
                  :key="tag.id"
                  class="d-none mt-2"
                  :class="{ 'd-flex': tag.type === 'adult' }"
                >
                  <v-list-item-title>
                    <v-chip
                      class="font-weight-medium text-sm-body-2"
                      color="blue lighten-4"
                      label
                      small
                      @click="search = tag.name"
                      >{{ tag.name }}</v-chip
                    >
                  </v-list-item-title>
                  <v-list-item-icon
                    @click="
                      id = tag.id;
                      name = tag.name;
                      selectedTagType = 'adult';
                      shwEditPopUp = true;
                    "
                  >
                    <v-icon small>mdi-pencil-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-icon
                    @click="
                      id = tag.id;
                      shwTagsQuestion = true;
                    "
                  >
                    <v-icon small>mdi-trash-can-outline</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </div>

              <v-card-actions>
                <v-btn
                  color="grey"
                  block
                  outlined
                  class="btn-add-tag text-capitalize caption font-weight-medium"
                  @click="
                    shwAddPopUp = true;
                    selectedTagType = 'adult';
                  "
                >
                  <v-icon dark class="caption"> mdi-plus </v-icon>
                  Add tag
                </v-btn>
              </v-card-actions>

              <!-- SPINNER -->
              <div
                v-if="!tags.length && loading"
                class="spinner-border text-primary spinner-position loading-spinner--center"
                role="status"
                style="top: 48% !important; left: 46% !important"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </v-card>
        </v-col>

        <!-- COL-3 -->
        <v-col
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3 card-height"
        >
          <v-card>
            <div>
              <v-card-title>Category tags</v-card-title>
              <v-divider></v-divider>
            </div>

            <div class="tags-content">
              <div class="tags-list">
                <v-list-item
                  v-for="tag in filteredTags"
                  :key="tag.id"
                  class="d-none mt-2"
                  :class="{ 'd-flex': tag.type === 'category' }"
                >
                  <v-list-item-title>
                    <v-chip
                      class="font-weight-medium text-sm-body-2"
                      color="deep-orange lighten-4"
                      label
                      small
                      @click="search = tag.name"
                      >{{ tag.name }}</v-chip
                    >
                  </v-list-item-title>
                  <v-list-item-icon
                    @click="
                      id = tag.id;
                      name = tag.name;
                      selectedTagType = 'category';
                      shwEditPopUp = true;
                    "
                  >
                    <v-icon small>mdi-pencil-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-icon
                    @click="
                      id = tag.id;
                      shwTagsQuestion = true;
                    "
                  >
                    <v-icon small>mdi-trash-can-outline</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </div>

              <v-card-actions>
                <v-btn
                  color="grey"
                  block
                  outlined
                  class="btn-add-tag text-capitalize caption font-weight-medium"
                  @click="
                    shwAddPopUp = true;
                    selectedTagType = 'category';
                  "
                >
                  <v-icon dark class="caption"> mdi-plus </v-icon>
                  Add tag
                </v-btn>
              </v-card-actions>

              <!-- SPINNER -->
              <div
                v-if="!tags.length && loading"
                class="spinner-border text-primary spinner-position loading-spinner--center"
                role="status"
                style="top: 48% !important; left: 46% !important"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </v-card>
        </v-col>

        <!-- COL-4 -->
        <v-col
          class="col-xs-12col-sm-12 col-md-6 col-lg-6 col-xl-3 card-height"
        >
          <v-card>
            <div>
              <v-card-title>Server tags</v-card-title>
              <v-divider></v-divider>
            </div>

            <div class="tags-content">
              <div class="tags-list">
                <v-list-item
                  v-for="tag in filteredTags"
                  :key="tag.id"
                  class="d-none mt-2"
                  :class="{ 'd-flex': tag.type === 'server' }"
                >
                  <v-list-item-title>
                    <v-chip
                      class="font-weight-medium text-sm-body-2"
                      color="purple lighten-4"
                      label
                      small
                      @click="search = tag.name"
                      >{{ tag.name }}</v-chip
                    >
                  </v-list-item-title>
                  <v-list-item-icon
                    @click="
                      id = tag.id;
                      name = tag.name;
                      selectedTagType = 'server';
                      shwEditPopUp = true;
                    "
                  >
                    <v-icon small>mdi-pencil-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-icon
                    @click="
                      id = tag.id;
                      shwTagsQuestion = true;
                    "
                  >
                    <v-icon small>mdi-trash-can-outline</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </div>

              <v-card-actions>
                <v-btn
                  color="grey"
                  block
                  outlined
                  class="btn-add-tag text-capitalize caption font-weight-medium"
                  @click="
                    shwAddPopUp = true;
                    selectedTagType = 'server';
                  "
                >
                  <v-icon dark class="caption"> mdi-plus </v-icon>
                  Add tag
                </v-btn>
              </v-card-actions>

              <!-- SPINNER -->
              <div
                v-if="!tags.length && loading"
                class="spinner-border text-primary spinner-position loading-spinner--center"
                role="status"
                style="top: 48% !important; left: 46% !important"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- POV tags-manager finish  -->

    <!-- Edit domain's tags -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <div class="overlay" v-if="shwAddPopUp || shwEditPopUp">
        <div class="tag-card">
          <div
            class="close"
            @click="
              name = '';
              shwEditPopUp = false;
              shwAddPopUp = false;
            "
          >
            <v-icon small>mdi-close</v-icon>
          </div>
          <v-card>
            <v-card-title class="h3 justify-center">
              {{ shwEditPopUp ? "Update" : "Create" }} tag
            </v-card-title>

            <v-row>
              <span class="h6">Tag Name<span class="asterisk">*</span></span>
              <v-col>
                <v-text-field
                  v-model="name"
                  label="Name"
                  :rules="[rules.required]"
                  :loading="processLoading"
                  solo
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <span class="h6">Tag Type<span class="asterisk">*</span></span>
              <v-col>
                <v-select
                  v-model="selectedTagType"
                  :items="tagTypes"
                  :rules="[rules.required]"
                  :loading="processLoading"
                  label="Type"
                  outlined
                  solo
                ></v-select>
              </v-col>
            </v-row>

            <v-card-actions class="justify-center">
              <v-btn
                color="grey"
                outlined
                @click="
                  name = '';
                  shwEditPopUp = false;
                  shwAddPopUp = false;
                "
              >
                Cancel
              </v-btn>

              <v-btn
                color="black"
                :loading="processLoading"
                @click="
                  shwAddPopUp ? create(name, selectedTagType) : update(name, id)
                "
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </div>
    </transition>

    <!-- Question Pop-up -->
    <Question
      v-if="shwTagsQuestion"
      @didClose="shwTagsQuestion = false"
      @confirmed="remove(id)"
      @notConfirmed="shwTagsQuestion = false"
      title="Are you sure?"
      text="You will delete this tag."
      confirmButtonText="Delete"
      cancelButtonText="Cancel"
      isConfirmedTitle="Deleted!"
      isConfirmedText="Tag has been deleted!"
      dismissTitle="Cancelled!"
      dismissText="Tag is in the safe :)"
      confirmButtonClasses="btn btn-success"
      cancelButtonClasses="btn btn-danger"
      successIcon="success"
      errorIcon="error"
    />

    <!-- Success Snackbar -->
    <transition
      class="animate__faster"
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__faster"
    >
      <SuccessSnackbar
        v-if="success"
        @update-success="handleUpdateToSuccessSnackbar"
        :message="'Successfully!'"
      />
    </transition>

    <!-- Failure Snackbar -->
    <transition
      class="animate__faster"
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__faster"
    >
      <FailureSnackbar
        v-if="failure"
        @update-failure="handleUpdateToFailureSnackbar"
        :message="failure"
      />
    </transition>

    <!-- Error Pop-up -->
    <Error v-if="tagsError" :error="tagsError" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Question from "../popUps/Question.vue";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";
import Spinner from "../popUps/Spinner.vue";
import Error from "../popUps/Error.vue";
import common from "../../mixins/common";

export default {
  name: "TagsManager",
  components: { SuccessSnackbar, FailureSnackbar, Question, Spinner, Error },
  mixins: [common],
  data: () => ({
    tagTypes: ["geo", "adult", "category", "server"],
    selectedTagType: "",
    search: "",
    name: "",
    failure: "",
    success: false,
    id: null,
    loading: true,
    processLoading: false,
    shwAddPopUp: false,
    shwEditPopUp: false,
    shwTagsQuestion: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    example: null,
  }),
  computed: {
    ...mapState({
      tags: (state) => state.tags.tags,
      tagsError: (state) => state.tags.tagsError,
    }),
    filteredTags() {
      return this.tags.filter((p) => {
        return p.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  created() {
    this.loading = true;
  },
  mounted() {
    this.showTags().finally(() => {
      this.$nextTick(() => {
        this.loading = false;
      });
    });
  },
  methods: {
    ...mapActions(["showTags", "createTag", "removeTag", "updateTag"]),
    /**
     * Create the tags.
     * @param {string} name - The tag name.
     * @param {string} type - The tag category.
     */
    create(name, type) {
      if (this.shwAddPopUp && this.name && this.selectedTagType) {
        this.processLoading = true;

        setTimeout(() => {
          this.shwAddPopUp = false;
          this.processLoading = false;

          this.name = "";
          this.selectedTagType = "";
        }, 2000);

        this.createTag({ name, type: type }).then(() => {
          this.success = true;
        });
      } else if (!this.name && !this.selectedTagType) {
        this.failure = "Fill the required fields out!";
      }
    },

    /**
     * Remove the tag.
     * @param {number} id - The tag id.
     */
    remove(id) {
      this.removeTag(id).then(() => {
        this.success = true;
      });
    },

    /**
     * Update the tag.
     * @param {string} name - The tag name.
     * @param {number} id - The tag id.
     */
    update(name, id) {
      if (this.shwEditPopUp && this.name && this.selectedTagType) {
        this.processLoading = true;

        setTimeout(() => {
          this.processLoading = false;
          this.shwEditPopUp = false;

          this.name = "";
          this.selectedTagType = "";
        }, 2000);

        this.updateTag({ name, id }).then(() => {
          this.success = true;
        });
      } else if (!this.name && !this.selectedTagType) {
        this.failure = "Fill the required fields out!";
      }
    },
  },
};
</script>

<style scoped>
.card-height {
  height: 357px;
}
</style>
